module.exports = __webpack_public_path__ + "img/swiper_04.5945f8eb.jpg";